import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject, Subscription } from 'rxjs';
import { AdministrativeService } from '../../services/adiq/administrative/administrative.service';
import { PinPadWebTefService } from '../../services/adiq/pinpad/pinpad-webtef.service';
import { DateUtilService } from '../../services/date-util.service';
import { takeUntil } from 'rxjs/operators';
import { Financial } from '../../model/Financial';
import * as moment from 'moment';
import { TransactionInfo } from '../../model/TransactionInfo';
import { environment } from '../../../../environments/environment';

const url_tx = environment.url_tx;
const port_tx = environment.port_tx;

enum WebTefComandos {
  BUSCAR_TERMINAL = '4200',
  CONFIGURAR_TERMINAL = '1030',
  STATUS = '1020',
  INICIALIZAR = '6666',
}

export class PinPadWebTefComponent {
  public pinpadIsInit: boolean = false;
  public serialNumber = null;
  public pinpadInfo: any = null;
  public terminalModel: any = null;
  public enterpriseFederalId: string;
  public listTerminais: Array<any> = [];
  public chatSub$: Observable<any>;
  public subscribe$: Subscription;
  messages: string[] = [];
  destroyed$ = new Subject();
  public port: string;
  public url_tx: string = url_tx;
  public port_tx: string = port_tx;

  constructor(
    public notificationService: NotificationsService,
    public spinnerService: NgxSpinnerService,
    public dateUtilService: DateUtilService,
    public pinPadService: PinPadWebTefService,
    public administrativeService: AdministrativeService
  ) {

  }


  conectar(){
    this.wsOpenConnection();
  }

  desconectar(){
    this.wsCloseConnection();
  }

  buscarTerminal(next?: Function){
    this.subscribe$ = this.chatSub$.subscribe(
      (message) => {
        const info: any = JSON.parse(message.data);
        if (info.Comando) {
          if (info.Comando === '4200') {
            if (info.Status === '00') {
              this.port = info.COM;
              if(next){
                next()
              }
            }else {
              this.notificationService.error('Pinpad não conectado');
            }
        //    this.subscribe$.unsubscribe();
          }
        }
      },
      (err) => {
        this.notificationService.error('Não possível buscar terminal');
      },
    );
    this.wsFindPinpad();
  }

  configurar(next?: Function){
    this.subscribe$ = this.chatSub$.subscribe(
      (message) => {
        const info: any = JSON.parse(message.data);
        if (info.Comando) {
          if (info.Comando === '1030') {
            if (info.Status === '00') {
               if(next){
                next()
              }
            }else{
              this.notificationService.error('Não possível realizar configuração');
            }
          }
       //   this.subscribe$.unsubscribe();
        }
      },
      (err) => {
        this.notificationService.error('Não possível realizar configuração');
      }
    );
    this.wsConfigurar();
  }

  inicializar(next?: Function){
    this.subscribe$ = this.chatSub$.subscribe(
      (message) => {
        const info: any = JSON.parse(message.data);
        if (info.Comando) {
          if (info.Comando === '6666') {
            if (info.Status === '00') {
              if(next) {
                next();
              }

            }else{
              this.notificationService.error('Não possível realizar inicializacao');
            }
          }
         // this.subscribe$.unsubscribe();
        }
      },
      (err) => {
        this.notificationService.error('Não possível realizar inicializacao');
      }
    );
    this.wsInit();
  }

  status(next?: Function){
    this.subscribe$ = this.chatSub$.subscribe(
      (message) => {
        const info: any = JSON.parse(message.data);
        if (info.Comando) {
          if (info.Comando === '1020') {
            if (info.Status === '00') {
              this.serialNumber = info.NSPP;
              this.pinpadIsInit = true;

            }

          }
        }
      },
      (err) => {
        this.notificationService.error('Não possível realizar inicializacao');
      },
      ()=>{
        console.log('complete')
        if(next) {
          next();
        }
      }
    );
    this.wsStatus();
  }



  pinpadInit() {

    this.wsOpenConnection();
    this.subscribe$ = this.chatSub$.subscribe(
      (message) => {
        const info: any = JSON.parse(message.data);
        if (info.Comando) {
          if (info.Comando === '4200') {
            if (info.Status === '00') {
              this.port = info.COM;
              this.wsConfigurar();
            }else {
              this.spinnerService.hide();
              this.notificationService.error('Pinpad não conectado');
              this.subscribe$.unsubscribe();
            }
          } else if (info.Comando === '1020') {
            if (info.Status === '00') {
              this.serialNumber = info.NSPP;
              this.pinpadIsInit = true;
              this.subscribe$.unsubscribe();
              this.spinnerService.hide();
              this.identificarTerminal();
            }
          } else if (info.Comando === '1030' && info.Status === '00') {
            this.wsInit();
          } else if (info.Comando === '6666' && info.Status === '00') {
            this.wsStatus();
          }
        }
      },
      (err) => {
        this.spinnerService.hide();
        this.notificationService.error('Não possível realizar a inicialização');
      }
    );

    setTimeout(() => {
      this.spinnerService.show();
      this.wsFindPinpad();
    },4000);
  }

  wsConfigurar() {
    let msg: any = {
      Comando: "1030",
      HostAddress: url_tx,
      HostPort: port_tx,
      SSL: true,
      ParcECJuros: "2",
      NII: "5",
      TentativasConexao: 3,
      TimeoutConexao: 30,
      TimeoutResposta: 30,
      PinpadPortName: this.port,
      AutoPinpadConfigure: false,
      IdAplicacao: "GERTEC02",
      VersaoAplicacao: "4200080000",
    };

    this.pinPadService.send(msg);
  }

  wsStatus() {
    let msg: any = {
      Comando: "1020",
    };

    this.pinPadService.send(msg);
  }

  wsFindPinpad() {
    let msg: any = {
      Comando: "4200",
    };

    this.pinPadService.send(msg);
  }

  wsLoadTables() {
    let msg: any = {
      Comando: "9000",
    };

    this.pinPadService.send(msg);
  }



  sendComand(mensagem: any,  handleSuccess: Function, handleError: Function){
    this.subscribe$ = this.chatSub$.subscribe(
      (message) => handleSuccess(message),
      (err) => handleError(err)
    );

    this.wsGeneric(mensagem);
  }

  wsGeneric(mensagem: any){
    this.pinPadService.send(mensagem);
  }

  wsInit() {
    let msg: any = {
      Comando: "6666",
    };

    this.pinPadService.send(msg);
  }

  wsAbertura() {
    let msg: any = {
      Comando: "1050",
    };

    this.pinPadService.send(msg);
  }

  wsOpenConnection(): void {
    this.chatSub$ = this.pinPadService
      .connect()
      .pipe(takeUntil(this.destroyed$));

  }

  wsCloseConnection(): void {
    this.pinPadService.closeConnection();
  }

  setup() {
    this.terminalModel = this.terminalLocalizado;
    if (!this.pinpadIsInit) {
      this.notificationService.warn("Pinpad não está ativo.");
      return;
    }
    if (this.terminalModel == null) {
      this.notificationService.warn("Selecione um terminal.");
      return;
    } else {
      if (this.serialNumber !== this.terminalModel.numeroSerie) {
       // this.pinpadIsInit = false;
        this.notificationService.warn("O terminal selecionado não corresponde ao terminal conectado.");
        return;
      }
      this.spinnerService.show();
      this.subscribe$ = this.chatSub$.subscribe(
        (message) => {
          const info: any = JSON.parse(message.data);
          if (info.Comando) {
            if (
              info.Comando === "1050" &&
              (info.Status === "00" || info.Status === "05")
            ) {
              this.subscribe$.unsubscribe();
            }
          }
          this.spinnerService.hide();
        },
        (err) => {
          this.spinnerService.hide();
          console.log(err);
        }
      );

      this.wsAbertura();
    }
  }

  wsVenda(data: Financial, successHandle: Function, errorHandle: Function) {
    let dataTransaction: Date = new Date();
    let tipoParcela = data.type === 4 || data.type === 1 ? 0 : 2;
    let bandeiras: Array<any> = null;

    if (data.flag === 'MASTERCARD') {
      bandeiras = [50];
    }else  if (data.flag === 'VISA') {
      bandeiras =  [31];
    }else  if (data.flag === 'ELO') {
      bandeiras =  [33];
    }
    let msg: any = {
      Comando: data.typeTransaction,
      Valor: (Number.parseFloat(data.valueTransaction) * 100).toFixed(0),
      Parcelas: data.plots,
      Trilha2: '',
      DataTx: moment(dataTransaction).format('MMDD'),
      HoraTx: moment(dataTransaction).format('HHmmss'),
      Cvv: '000',
      TipoParcela: tipoParcela,
      ModoParcelada: 2,
      Bandeiras: []
    };
    this.subscribe$ = this.chatSub$.subscribe(
      (message) => {
        successHandle(message, msg)
      },
      (err) =>{
        errorHandle(err)
      }
    );
    this.pinPadService.send(msg);
  }

  wsEstorno(data: TransactionInfo, successHandle: Function, errorHandle: Function) {

    let dataTransaction: Date = new Date();

    let msg: any = {
      Comando: '4000',
      Valor: (Number.parseFloat(data.valor) * 100).toFixed(0),
      Parcelas: data.qtdParcelas,
      Trilha2: '',
      DataTx: moment(dataTransaction).format('MMDD'),
      HoraTx: moment(dataTransaction).format('HHmmss'),
      Cvv: '000',
      NumDocumento: data.nsuTerminal,
    };

    if (data.modalidade === 'CREDITO' && data.qtdParcelas != null && data.qtdParcelas.toString() !== '1' ) {
      msg['ModoParcelada'] = 2;
      msg['TipoParcela'] = 2;
    }


    this.subscribe$ = this.chatSub$.subscribe(
      (message) => successHandle(message, msg),
      (err) => errorHandle(err)
    );
    this.pinPadService.send(msg);
  }

  setPinpadInitValues() {
    if (this.pinpadInfo != null) {
      this.listTerminais.forEach((terminal) => {
        if (
          terminal.numeroSerie === this.pinpadInfo.numeroSerie &&
          terminal.codigoEstabelecimento ===
            this.pinpadInfo.codigoEstabelecimento &&
          terminal.codigoTerminal === this.pinpadInfo.codigoTerminal
        ) {
          //     this.terminalModel = terminal;
        }
      });
    }
  }

  public terminalLocalizado: any = null;
  public terminalLocalizadoInfoText: string = 'Localizando terminal...';

  forceIdentificarTerminal(){
    if(this.terminalLocalizadoInfoText === 'Localizando terminal...'){
      return;
    }

    this.identificarTerminal();
  }

  identificarTerminal() {

    this.terminalLocalizadoInfoText = 'Localizando terminal...';

    if (this.listTerminais == null || this.listTerminais.length === 0) {
      this.notificationService.warn('A lista de terminais não foi carregada.');
      this.terminalLocalizadoInfoText = 'A lista de terminais não foi carregada.';
      return;
    }

    if (this.serialNumber == null){
      this.notificationService.warn('Terminal não localizado.');
      this.terminalLocalizadoInfoText = 'Terminal não localizado.';
      return;
    }

    const terminaisFilter: Array<any> =
      this.listTerminais.filter(terminal => terminal.numeroSerie === this.serialNumber);
    if (terminaisFilter != null && terminaisFilter.length > 0) {
      this.terminalLocalizado = terminaisFilter[0];
      this.terminalLocalizadoInfoText = 'Terminal: '.concat(this.terminalLocalizado.numeroSerie);
    }else {
      this.notificationService.warn('Terminal não se encontra na lista de terminais.');
      this.terminalLocalizadoInfoText = 'Terminal não se encontra na lista de terminais.';
      return;
    }

    localStorage.setItem(
      'pinpadConfigWebtef',
       JSON.stringify({type: 'webtef' , port: this.port , 'serialNumber': this.serialNumber,  lastCharge: moment(new Date()).format('YYYY-MM-DD')})
    );
  }

  terminalVerify(pinpadConfig: any){
    this.spinnerService.show();

    let successHandleStatusTerminal: Function = (message) =>{
      const info: any = JSON.parse(message.data);
      if(info.Comando ===  WebTefComandos.STATUS){
        if (info.Status === '00') {
          this.serialNumber = info.NSPP;
          this.subscribe$.unsubscribe();

          if(pinpadConfig != null) {
            pinpadConfig = JSON.parse(pinpadConfig);
            if(pinpadConfig.type !== 'webtef' ||
             pinpadConfig.lastCharge !== moment(new Date()).format('YYYY-MM-DD') ||
             pinpadConfig.port !== this.port ||
             pinpadConfig.serialNumber !==  this.serialNumber ) {
              this.fullTerminalInit();
            }else{
              this.pinpadIsInit = true;
              this.identificarTerminal();
              this.spinnerService.hide();
            }
          }else {
            this.fullTerminalInit();
          }
        }
      }
    }

    let successHandleConfigurarTerminal: Function = (message) =>{
      const info: any = JSON.parse(message.data);
      if (info.Comando === WebTefComandos.CONFIGURAR_TERMINAL && info.Status === '00') {
        let msgStatus: any = {
          Comando: WebTefComandos.STATUS,
        };
        this.sendComand(msgStatus, successHandleStatusTerminal , erroHandle)
      }
    }

    let successHandleBuscaTerminal: Function = (message) =>{
      const info: any = JSON.parse(message.data);
      if (info.Comando === WebTefComandos.BUSCAR_TERMINAL) {
        if (info.Status === '00') {
          this.port = info.COM;

          this.port = info.COM;
          let configMsg: any = {
            Comando: WebTefComandos.CONFIGURAR_TERMINAL,
            HostAddress: this.url_tx,
            HostPort: this.port_tx,
            SSL: true,
            ParcECJuros: "2",
            NII: "5",
            TentativasConexao: 3,
            TimeoutConexao: 30,
            TimeoutResposta: 30,
            PinpadPortName: this.port,
            AutoPinpadConfigure: false,
            IdAplicacao: "GERTEC02",
            VersaoAplicacao: "4200080000",
          };


          this.sendComand(configMsg, successHandleConfigurarTerminal , erroHandle)
        }else {
          this.spinnerService.hide();
          this.notificationService.error('Pinpad não conectado');
          this.subscribe$.unsubscribe();
        }
      }
    }

    let erroHandle: Function = (error) =>{
      this.spinnerService.hide();
      this.notificationService.error('Não foi possível conectar a aplicação.')
    }

    let msg: any = {
      Comando: WebTefComandos.BUSCAR_TERMINAL,
    };

    this.conectar();
    this.sendComand(msg, successHandleBuscaTerminal , erroHandle)
  }

  fullTerminalInit(){
    this.spinnerService.show();
    let successHandleStatusTerminal: Function = (message) =>{
      const info: any = JSON.parse(message.data);
      if(info.Comando ===  WebTefComandos.STATUS){
        if (info.Status === '00') {
          this.serialNumber = info.NSPP;
          this.pinpadIsInit = true;
          this.subscribe$.unsubscribe();
          this.spinnerService.hide();
          this.identificarTerminal();
        }
      }
    }

    let successHandleInicializarTerminal: Function = (message) =>{
      const info: any = JSON.parse(message.data);
      if (info.Comando === WebTefComandos.INICIALIZAR && info.Status === '00') {
        let msgStatus: any = {
          Comando: WebTefComandos.STATUS,
        };
        this.sendComand(msgStatus, successHandleStatusTerminal , (err) => erroHandle);
      }
    }

    let successHandleConfigurarTerminal: Function = (message) =>{
      const info: any = JSON.parse(message.data);
      if (info.Comando === WebTefComandos.CONFIGURAR_TERMINAL && info.Status === '00') {
        let msgInicializar: any = {
          Comando: WebTefComandos.INICIALIZAR,
        };
        this.sendComand(msgInicializar, successHandleInicializarTerminal , erroHandle)
      }
    }

    let successHandleBuscaTerminal: Function = (message) =>{
      const info: any = JSON.parse(message.data);
      if (info.Comando === WebTefComandos.BUSCAR_TERMINAL) {
        if (info.Status === '00') {
          this.port = info.COM;
          let configMsg: any = {
            Comando: WebTefComandos.CONFIGURAR_TERMINAL,
            HostAddress: this.url_tx,
            HostPort: this.port_tx,
            SSL: true,
            ParcECJuros: "2",
            NII: "5",
            TentativasConexao: 3,
            TimeoutConexao: 30,
            TimeoutResposta: 30,
            PinpadPortName: this.port,
            AutoPinpadConfigure: false,
            IdAplicacao: "GERTEC02",
            VersaoAplicacao: "4200080000",
          };
          this.sendComand(configMsg, successHandleConfigurarTerminal , erroHandle)
        }else {
          this.spinnerService.hide();
          this.notificationService.error('Pinpad não conectado');
          this.subscribe$.unsubscribe();
        }
      }
    }

    let erroHandle: Function = (error) =>{
      this.spinnerService.hide();
      this.notificationService.error('Não foi possível conectar a aplicação.')
    }

    let stautsMsg: any = {
      Comando: WebTefComandos.BUSCAR_TERMINAL,
    };

    this.conectar();
    this.sendComand(stautsMsg, successHandleBuscaTerminal , erroHandle)
  }
}
